import React from "react";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Link, NavLink } from "react-router-dom";

const useStyles = (theme) => ({
  title: {
    flexGrow: 1,
    fontFamily: ["Roboto Mono"],
    fontWeight: "700",
  },
  titleLink: {
    color: "#FFF",
    textDecoration: "none",
  },
  AppBar: {
    backgroundColor: "#26a69a",
    marginBottom: "20px",
  },
  "@media (max-width: 600px)": {
    title: {
      fontSize: "16px",
    },
  },
});

export default function Navbar() {
  const classes = useStyles();
  return (
    <>
      <div className={classes.root}>
        <AppBar position="static" style={classes.AppBar}>
          <Container maxWidth="md">
            <Toolbar className="d-flex justify-content-between">
              <Typography variant="h6" style={classes.title}>
                <Link style={classes.titleLink} to="/">
                  Rafael de Melo
                </Link>
              </Typography>
              <ButtonGroup
                className="desk-nav"
                color="inherit"
                aria-label="outlined primary button group"
              >
                <Button
                  component={NavLink}
                  exact
                  to="/"
                  activeClassName="nav-active"
                >
                  Home
                </Button>

                <Button
                  component={NavLink}
                  to="/portfolio"
                  activeClassName="nav-active"
                >
                  Portfolio
                </Button>

                <Button
                  component={NavLink}
                  exact
                  to="/contato"
                  activeClassName="nav-active"
                >
                  Contato
                </Button>
              </ButtonGroup>
            </Toolbar>
          </Container>
        </AppBar>
      </div>
    </>
  );
}
